export default __webpack_public_path__ + "static/055-b39a3dbf5653a321e7c7c190b2930836.jpg";